import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const hash = location.hash || "";
      const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
      const sessionId = params.get("session_id");
      if (!sessionId) { navigate("/login"); return; }
      try {
        const { data } = await http.post("/auth/session", { session_id: sessionId });
        auth?.setUser?.(data.user);
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { state: { user: data.user }, replace: true });
      } catch (e) {
        console.error("OAuth session exchange failed:", e);
        navigate("/login");
      }
    })();
    // Intentional single-run effect: hasProcessed ref guards against StrictMode double-invocation,
    // and location/auth references are captured on first render for the OAuth callback flow.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-cream text-viola" data-testid="auth-callback">
      <p>Accesso in corso…</p>
    </div>
  );
}
